module.exports = __webpack_public_path__ + "img/iriomote_9.228d00b7.jpg";